<template>
  <b-modal title="Informações Sobre a Equipe" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Lider:" label-for="lider" label-cols="3" label-align="right">
            <b-form-input id="lider" v-model="editing.lider" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Descrição:" label-for="descricao" label-cols="3" label-align="right">
            <b-form-input id="descricao" v-model="editing.descricao" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Data:" label-for="data" label-cols="3" label-align="right">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Custo:" label-for="custo" label-cols="3" label-align="right">
            <b-form-input id="custo" v-model.lazy="editing.custo" v-money="money" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useEquipeStore } from "@/stores/EquipeStore";
import { VMoney } from "v-money";
import Equipe from "@/models/Equipe";
import Notificacao from "@/models/Notificacao";

export default {
  name: "ModalDeEdicaoDeEquipe",

  data() {
    return {
      show: false,
      editing: new Equipe(0, "", "Nova Equipe", new Date(), 0.0),
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },

  directives: { money: VMoney },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.equipeStore.ALTERAR_EQUIPE(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Equipe foi salva no SGCQ com sucesso!", "Excelente!", "success"));
        });
      } else {
        this.equipeStore
          .CADASTRAR_EQUIPE(this.editing)
          .then(() => this.store.NOTIFICAR(new Notificacao("Equipe foi salva no SGCQ com sucesso!", "Excelente!", "success")));
      }
      this.show = !this.show;
    },

    call(equipe) {
      this.show = !this.show;
      this.editing = equipe;
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipeStore = useEquipeStore();

    return {
      store,
      equipeStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
